import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ShopPopup from "@/components/ShopPopup";

export default function Layout() {
  return (
    <div className="bg-gg-black min-h-screen">
      <Navbar />
      <main className="pt-12 md:pt-14">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <ShopPopup />
    </div>
  );
}
